import React from 'react';
import { Drawer, Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { decode } from '../../utils/Utils';
import logo from '../../icons/logo.svg';

interface UnsupportHostageDrawerProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  hostageName: string;
}

const UnsupportHostageDrawer: React.FC<UnsupportHostageDrawerProps> = ({ open, onClose, onConfirm, hostageName }) => {
  const { t } = useTranslation();

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
    >
    <Box sx={{padding: '8px, 16px, 24px, 16px', margin: '16px', textAlign: 'center'}}>
        <Box
              sx={{
                backgroundColor: '#ccc',
                borderRadius: 2,
                margin: '10px auto',
                cursor: 'pointer'
              }}
              onClick={onClose}
          />
        <Box component="img" src={logo} alt="App Logo" sx={{width: 60, margin: '20px auto'}}/>
        <Typography variant="h6">
          {t('hostageCard.confirmUnsupportTitle')}
        </Typography>
        <Typography variant="body2" sx={{ margin: '20px 0' }}>
          {decode(t('hostageCard.confirmUnsupportText', { name: hostageName }))}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 2 }}>
          <Button onClick={onConfirm} variant="contained" sx={{ marginBottom: 2, width: "90%", height: "50px", background:"#FF395D", borderRadius: "8px" }}>
            {t('hostageCard.yes')}
          </Button>
          <Button onClick={onClose} variant="contained" sx={{ marginBottom: 2, width: "90%", height: "50px", background:"white", color: "#FF395D", border: "1px solid #FF395D !important", borderRadius: "8px" }}>
            {t('hostageCard.no')}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default UnsupportHostageDrawer;
